// Palette SanitDocs — partagée entre Tailwind (CJS) et l'app (ESM via webpack)
module.exports = {
  brand: {
    50: "#EEF4FF", 100: "#D9E6FF", 200: "#B3CCFF", 300: "#7FA8F5", 400: "#4A7FE3",
    500: "#1D5BD6", 600: "#1447B5", 700: "#0B3C8C", 800: "#082D6B", 900: "#061F4C",
  },
  accent: {
    50: "#ECF8FF", 100: "#D3EEFF", 200: "#A9DDFF", 300: "#6CC4FB", 400: "#33A9F1",
    500: "#0E8FE0", 600: "#0673C2", 700: "#065C9E", 800: "#0A4C82", 900: "#0D3F6B",
  },
  success: "#10B981",
  warning: "#F97316",
  danger: "#EF4444",
  neutral: "#64748B",
  surface: "#FFFFFF",
  background: "#F5F8FC",
};
